import * as React from 'react';

/**
 * @note
 * This a workaround implementation of the hook avoids the following warning:
 *
 * Warning: useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer’s
 * output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this,
 * useLayoutEffect should only be used in components that render exclusively on the client.
 * See https://fb.me/react-uselayouteffect-ssr for common fixes.
 */
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
